// extracted by mini-css-extract-plugin
export var container = "_uh-0";
export var table = "_uh-2";
export var tableWrapper = "_uh-1";